// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__KLeIj","iconWithCounter":"styles_iconWithCounter__yKxvg","counterForLabel":"styles_counterForLabel__RQCjy","counterForIcon":"styles_counterForIcon__qY9XJ"};